export enum CustomHeader {
    SkipLoadingHeader = 'X-Skip-Loading',
    SkipNotificationHeader = 'X-Skip-Notification',
}
